/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createVendorFromDiscriminatorValue, serializeDeactivateVendorRequest, serializeUpdateVendorRequest, serializeVendor, type DeactivateVendorRequest, type ErrorResponse, type InternalErrorResponse, type UpdateVendorRequest, type Vendor } from '../../../models/index.js';
// @ts-ignore
import { CustomersRequestBuilderRequestsMetadata, type CustomersRequestBuilder } from './customers/index.js';
// @ts-ignore
import { ImagesRequestBuilderNavigationMetadata, type ImagesRequestBuilder } from './images/index.js';
// @ts-ignore
import { OrdersRequestBuilderRequestsMetadata, type OrdersRequestBuilder } from './orders/index.js';
// @ts-ignore
import { ReactivateRequestBuilderRequestsMetadata, type ReactivateRequestBuilder } from './reactivate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/vendors/{vendorCode}
 */
export interface WithVendorCodeItemRequestBuilder extends BaseRequestBuilder<WithVendorCodeItemRequestBuilder> {
    /**
     * The customers property
     */
    get customers(): CustomersRequestBuilder;
    /**
     * The images property
     */
    get images(): ImagesRequestBuilder;
    /**
     * The orders property
     */
    get orders(): OrdersRequestBuilder;
    /**
     * The reactivate property
     */
    get reactivate(): ReactivateRequestBuilder;
    /**
     * Takes a line off the agency's vendors without removing it: the document stays, with active false, so the code stays reserved and the customer accounts under it are kept. Refused with 409 while any product in the organization still carries the vendor's code as its SKU prefix — move those products to another vendor or delete them first. Deactivating a vendor that is already inactive succeeds quietly with 204, so a retry is safe. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeactivateVendorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns one of the agency's vendors by its code, in any casing. A deactivated vendor is still returned, with active false, because its code stays reserved and its products keep resolving. Admins and sales reps of an agency organization may read vendors; a Supplier organization is refused with 403.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Vendor>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithVendorCodeItemRequestBuilderGetQueryParameters> | undefined) : Promise<Vendor | undefined>;
    /**
     * Replaces the vendor named by the route with the body: name, line-card copy, commercial rules, order destination, linked organization and contact details. Send the whole vendor — a list left out is stored empty and a field left out is cleared. A logo or lifestyle image URL that is not in the platform's image storage is copied into it and the stored URL is kept; the pictures a save replaces are trashed. The vendor code cannot change: it is part of the vendor's identifier and the prefix of every SKU of the line, so renaming a line is a migration, not an edit. A deactivated vendor can still be edited. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Vendor>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateVendorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Vendor | undefined>;
    /**
     * Takes a line off the agency's vendors without removing it: the document stays, with active false, so the code stays reserved and the customer accounts under it are kept. Refused with 409 while any product in the organization still carries the vendor's code as its SKU prefix — move those products to another vendor or delete them first. Deactivating a vendor that is already inactive succeeds quietly with 204, so a retry is safe. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeactivateVendorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns one of the agency's vendors by its code, in any casing. A deactivated vendor is still returned, with active false, because its code stays reserved and its products keep resolving. Admins and sales reps of an agency organization may read vendors; a Supplier organization is refused with 403.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithVendorCodeItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Replaces the vendor named by the route with the body: name, line-card copy, commercial rules, order destination, linked organization and contact details. Send the whole vendor — a list left out is stored empty and a field left out is cleared. A logo or lifestyle image URL that is not in the platform's image storage is copied into it and the stored URL is kept; the pictures a save replaces are trashed. The vendor code cannot change: it is part of the vendor's identifier and the prefix of every SKU of the line, so renaming a line is a migration, not an edit. A deactivated vendor can still be edited. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateVendorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns one of the agency's vendors by its code, in any casing. A deactivated vendor is still returned, with active false, because its code stays reserved and its products keep resolving. Admins and sales reps of an agency organization may read vendors; a Supplier organization is refused with 403.
 */
export interface WithVendorCodeItemRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithVendorCodeItemRequestBuilderUriTemplate = "{+baseurl}/api/vendors/{vendorCode}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithVendorCodeItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithVendorCodeItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    customers: {
        requestsMetadata: CustomersRequestBuilderRequestsMetadata,
    },
    images: {
        navigationMetadata: ImagesRequestBuilderNavigationMetadata,
    },
    orders: {
        requestsMetadata: OrdersRequestBuilderRequestsMetadata,
    },
    reactivate: {
        requestsMetadata: ReactivateRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithVendorCodeItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithVendorCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeactivateVendorRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: WithVendorCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVendorFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithVendorCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVendorFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateVendorRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
